import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';

@Component({
    selector: '',
    template: '',
    standalone: false
})
export class CsStepsSummaryBaseComponent
{
    constructor (
        protected store: Store<IAuroraState>
    )
    { }

    gotoStep (stepIdx: number)
    {
        this.store.dispatch(fromRootStore.RootMiscStoreActions.RootWizardStepActivated({ stepIdx: stepIdx }));
    }
}
